// @flow

const COL_TENANT_WIDTH = 250;
const COL_ADDRESS_WIDTH = 300;
const COL_CHECKBOX_WIDTH = 44;
const COL_OTHER_WIDTH = 200;
const COL_PHONE_WIDTH = 175;
const COL_TAG_WIDTH = 300;
const COL_APT_WIDTH = 150;
const COL_EMAIL_WIDTH = 150;
const COL_ACTION_WIDTH = 220;
const MOBILE_COL_TENANT_WIDTH = 300;

const tenantsContentStyles = {
  checkboxIcon: (theme) => ({
    padding: 0,
    color: theme.palette.border.color,
    fontSize: '1.6rem',
    '&:hover': {
      color: theme.palette.primary.light
    }
  }),

  table: (theme) => ({
    display: 'table'
  }),

  accordionRoot: (theme) => ({
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2)
  }),

  accordionSummaryRoot: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.5rem'
    }
  }),

  selected: (theme) => ({
    color: theme.palette.primary.light
  }),

  colAction: (theme) => ({
    width: COL_ACTION_WIDTH
  }),

  checkboxHeadCell: (theme) => ({
    display: 'inline-table',
    padding: '0px 8px',
    marginRight: 0,
    '& > span > svg': {
      fontSize: '1.6rem'
    }
  }),

  customerTableContent: (theme) => ({
    padding: theme.spacing(3),
    width: '100%',
    minWidth: 1100,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      padding: 0
      // paddingTop is now handled by ContentContainer wrapper
    }
  }),

  checkboxCell: (theme) => ({
    flex: '0 0 auto',
    flexBasis: COL_CHECKBOX_WIDTH,
    maxWidth: COL_CHECKBOX_WIDTH,
    cursor: 'pointer',
    padding: `${parseInt(theme.spacing(1.7), 10)}px ${parseInt(theme.spacing(1.5), 10)}px ${parseInt(theme.spacing(1), 10)}px ${parseInt(theme.spacing(2), 10)}px`,
    height: 52,
    background: 'white',
    borderTopLeftRadius: 24,
    borderBottomLeftRadius: 24,
    borderBottom: 0,
    '& span svg': {
      fontSize: '1.6rem'
    }
  }),

  tenantCell: (theme) => ({
    flex: '0 0 auto',
    flexBasis: COL_OTHER_WIDTH,
    maxWidth: COL_TENANT_WIDTH,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 auto',
      flexBasis: COL_OTHER_WIDTH,
      maxWidth: MOBILE_COL_TENANT_WIDTH,
      cursor: 'pointer',
      overflowX: 'scroll'
    }
  }),

  aptCell: (theme) => ({
    flex: '0 0 auto',
    minWidth: COL_APT_WIDTH,
    maxWidth: COL_APT_WIDTH,
    overflowX: 'scroll'
  }),

  dateCell: (theme) => ({
    flex: '1 1 auto !important',
    minWidth: COL_EMAIL_WIDTH,
    maxWidth: '100% !important',
    paddingRight: 0,
    paddingLeft: 0,
    width: 'auto',
    overflowX: 'scroll',
    cursor: 'pointer'
  }),

  addressCell: (theme) => ({
    flex: '1 1 auto',
    flexBasis: COL_ADDRESS_WIDTH,
    overflowX: 'scroll'
  }),

  phoneCell: (theme) => ({
    flex: '0 0 auto',
    minWidth: COL_PHONE_WIDTH,
    maxWidth: COL_PHONE_WIDTH,
    overflowX: 'scroll'
  }),

  tagCell: (theme) => ({
    flex: '0 0 auto',
    minWidth: COL_TAG_WIDTH,
    maxWidth: COL_TAG_WIDTH,
    overflowX: 'scroll'
  }),

  actionCell: (theme) => ({
    flex: '0 0 auto',
    minWidth: theme.shape.borderRadius,
    paddingRight: 0,
    paddingLeft: 0,
    width: 'auto',
    overflowX: 'scroll'
  }),

  customTableStyles: (theme) => ({
    '& .underActionCell': {
      flex: '0 0 auto',
      minWidth: COL_ACTION_WIDTH,
      maxWidth: COL_ACTION_WIDTH,
      paddingRight: 0,
      paddingLeft: theme.spacing(1),
      width: 'auto'
    },
    '& .hover .underActionCell.twoBtns': {
      flex: '1 1 auto',
      minWidth: COL_ACTION_WIDTH - (theme.shape.borderRadius * 2 * 2),
      maxWidth: COL_ACTION_WIDTH - (theme.shape.borderRadius * 2 * 2),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'auto'
    }
  }),

  expansionPanelSummaryRoot: (theme) => ({
    minHeight: '48px !important',
    height: 48,
    marginTop: '1rem'
  }),

  resultsCount: (theme) => ({
    color: theme.palette.custom.backgroundTextInfo,
    fontSize: '0.8rem',
    marginBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingBottom: 0,
      marginBottom: 0,
      paddingLeft: theme.spacing(2),
      fontSize: '0.8rem'
    }
  }),

  heading: (theme) => ({
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2.5),
    paddingBottom: theme.spacing(0)
  }),

  heading2: (theme) => ({
    paddingTop: theme.spacing(4)
  }),

  expansionPanelDetails: (theme) => ({
    paddingBottom: theme.spacing(1)
  }),

  anchorTopRight: (theme) => ({
    transform: 'translate( 100%, -30%)'
  }),

  arrowIcon: (theme) => ({
    fontSize: '1.2rem',
    position: 'relative',
    top: 1,
    marginLeft: theme.spacing(0.375),
    color: '#66666a',
    verticalAlign: 'text-bottom'
  }),

  // Container layout styles
  tableContentWrapper: (theme) => ({
    minWidth: 'auto', // Remove fixed width constraint that causes overflow
    display: 'flex',
    flexDirection: 'column',
    height: '100%', // Ensure container takes available height
    [theme.breakpoints.down('sm')]: {
      height: 'auto' // On mobile, use natural content height
    }
  }),

  mainContentContainer: (theme) => ({
    flex: '1 1 auto', 
    display: 'flex', 
    flexDirection: 'column',
    minHeight: 0,
    height: 'auto' // Allow natural content height
  }),

  tableWrapper: (theme) => ({
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'visible', // Allow content to be visible
    width: '100%'
  })
};

export default tenantsContentStyles;